/**
 * Default timing constants for stagger animations (milliseconds).
 */ import { motionTokens } from '@fluentui/react-motion';
/** Default delay in milliseconds between each item's animation start */ export const DEFAULT_ITEM_DELAY = motionTokens.durationFaster;
/** Default duration in milliseconds for each item's animation */ export const DEFAULT_ITEM_DURATION = motionTokens.durationNormal;
